module.exports = __webpack_public_path__ + "static/media/float_logo.121cd14f.png";